module.exports = __webpack_public_path__ + "img/J.b95e15cd.jpg";